import React from 'react';
import { motion } from 'framer-motion';
import { containerVariants } from './animations';
interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}
export function PageContainer({
  children,
  className = 'space-y-8 pb-12'
}: PageContainerProps) {
  return <motion.div className={className} variants={containerVariants} initial="hidden" animate="visible" data-id="element-1797">
      {children}
    </motion.div>;
}